module.exports = __webpack_public_path__ + "img/info-04.5c4a7ece.jpg";